import React from 'react';

const CupOfCoffee = () => {
  return (
    <div className='CupOfCoffee'>
      <svg
        width='72'
        height='72'
        viewBox='0 0 72 72'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.9372 50.1059L21.1738 50.6292L21.6971 53.3926L24.4605 52.8692L23.9372 50.1059Z'
          fill='currentColor'
        />
        <path
          d='M49.3518 15.5294L46.5884 16.0527L47.1117 18.8161L49.8751 18.2927L49.3518 15.5294Z'
          fill='currentColor'
        />
        <path
          d='M42.3477 29.6359C43.1243 29.6359 43.7539 29.0063 43.7539 28.2297C43.7539 27.453 43.1243 26.8234 42.3477 26.8234C41.571 26.8234 40.9414 27.453 40.9414 28.2297C40.9414 29.0063 41.571 29.6359 42.3477 29.6359Z'
          fill='currentColor'
        />
        <path
          d='M15.5239 47.9889C16.3006 47.9889 16.9302 47.3593 16.9302 46.5826C16.9302 45.806 16.3006 45.1764 15.5239 45.1764C14.7473 45.1764 14.1177 45.806 14.1177 46.5826C14.1177 47.3593 14.7473 47.9889 15.5239 47.9889Z'
          fill='currentColor'
        />
        <path
          d='M37.5763 36.0206L37.3274 35.9273C37.2727 35.9067 31.8292 33.8211 29.2793 29.0922C26.7292 24.363 27.9778 18.669 27.9907 18.6122L28.0495 18.3528L28.2983 18.4461C28.353 18.4668 33.7964 20.5523 36.3465 25.2813C38.8965 30.0105 37.6479 35.7045 37.635 35.7613L37.5763 36.0206ZM29.6876 28.872C31.8435 32.8704 36.1451 34.92 37.235 35.3879C37.4422 34.2197 38.0921 29.496 35.9381 25.5014C33.7844 21.5074 29.4811 19.4546 28.3907 18.9856C28.1834 20.1544 27.5337 24.8777 29.6876 28.872Z'
          fill='currentColor'
        />
        <path
          d='M31.4244 27.8261C36.007 30.5832 37.7719 36.0595 37.7719 36.0595C37.7719 36.0595 32.1069 37.0657 27.5243 34.3086C22.9417 31.5516 21.1768 26.0753 21.1768 26.0753C21.1768 26.0753 26.8417 25.0691 31.4244 27.8261Z'
          fill='currentColor'
        />
        <path
          d='M36.8782 51.3734C33.1809 51.3692 29.6362 49.8986 27.0218 47.2842C24.4074 44.6698 22.9368 41.1252 22.9326 37.4279V37.2314H50.8237V37.4279C50.8195 41.1252 49.3489 44.6698 46.7345 47.2842C44.1201 49.8986 40.5755 51.3692 36.8782 51.3734ZM23.3268 37.6243C23.3784 41.1843 24.8288 44.581 27.3646 47.0803C29.9004 49.5796 33.3178 50.9806 36.8782 50.9806C40.4386 50.9806 43.856 49.5796 46.3917 47.0803C48.9275 44.581 50.3779 41.1843 50.4295 37.6243H23.3268Z'
          fill='currentColor'
        />
        <path
          d='M36.878 48.9182C39.3264 48.9182 41.6745 47.9456 43.4057 46.2143C45.137 44.4831 46.1096 42.135 46.1096 39.6866H27.6465C27.6465 42.135 28.6191 44.4831 30.3503 46.2143C32.0816 47.9456 34.4297 48.9182 36.878 48.9182Z'
          fill='currentColor'
        />
        <path
          d='M48.9579 50.9806H25.7808V51.3734H48.9579V50.9806Z'
          fill='currentColor'
        />
      </svg>
    </div>
  );
};

export default CupOfCoffee;
